import React from "react";
import { Icon, Label } from "semantic-ui-react";
import PopUpIcon from "@commonComponents/formComponents/PopUpIcon";

const getText =(countryList,countryCode)=>{
  let routingCountry = countryList?.find(item=>item.value===countryCode)
  return routingCountry?.text 
}

const DisplaySelectedCountryList=({dataSource,deleteItem,countryList,isFormDisabled})=>{
  return dataSource.map((item, index) => {
    const countryText=getText(countryList,item?.countryCode)
    if(!countryText) return null
    return( 
      <Label key={item?.id} >
        {item?.countryCode}
        <PopUpIcon icon='info circle' style={{marginLeft:'2px', marginRight:'2px'}} popupText={countryText} />
        <Icon
              id={`${index}-deleteContainerOuter`}
              name="delete"
              disabled={isFormDisabled}
              onClick={() =>deleteItem(item?.id)}
            />
       
      </Label>
    );
  });
}
export default DisplaySelectedCountryList

